<template>
	<div>
		<el-dialog title="审查" :visible.sync="dialogVisible" width="1198px" :before-close="handleClose">
			<div class="content">
				<step :active.sync="active" :stepArr="stepArr" :width="width"></step>
				<div v-if="active==0">
					<div class="head-descriptions">
						<el-descriptions>
							<el-descriptions-item label="申请单位">
								中富华商(北京)企业管理有限公司
							</el-descriptions-item>
							<el-descriptions-item label="编号">2022001</el-descriptions-item>
						</el-descriptions>
					</div>
					<div>
						<div class="pane-content">
							<div class="content-item" v-for="(item,index) in list">
								<div class="item-title">{{item.title}}</div>
								<div class="item-cont" v-for="(i,ix) in item.children">
									<div :style="{width:(i.options ? '35%':'calc(100% - 500px)')}">{{i.title}}</div>
									<!-- <div style="width: 25%;" v-if="i.options">
										<el-radio-group v-model="i.optionValue" v-if="typeof(i.optionValue)=='string'">
											<el-radio :label="r" v-for="(r,ri) in i.options">{{r}}</el-radio>
										</el-radio-group>
										<el-checkbox-group v-model="i.optionValue" v-if="typeof(i.optionValue)=='object'">
											<el-checkbox :label="r" v-for="(r,ri) in i.options"></el-checkbox>
										</el-checkbox-group>
									</div> -->
									<div class="cont-right">
										<div class="right-item" :class="{'conform ':i.isActive==0}"
											@click="checkItem(i,0)">
											符合要求
											<img class="checkImg" v-if="i.isActive==0"
												src="@/assets/images/11639@3x.png" alt="">
										</div>
										<div class="right-item" :class="{'unConform':i.isActive==1}"
											@click="checkItem(i,1)">不符合要求
											<img class="checkImg" v-if="i.isActive==1"
												src="@/assets/images/21639@3x.png" alt="">
										</div>
										<el-input v-model="i.value" placeholder="请输入备注信息"></el-input>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="active==1">
					<div class="pane-content">
						<div class="content-item" v-for="(item,index) in twolist">
							<div class="item-title">{{item.title}}</div>
							<div class="item2-cont" v-for="(i,ix) in item.children">
								<div class="cont-title">
									<div class="square"></div>
									{{i.title}}
								</div>
								<div class="cont-list" v-for="(a,ai) in i.children">
									<div style="width: 60%;" v-if="i.type===1">{{ai+1}}、{{a.title}}</div>
									<div style="width: 60%;" v-if="i.type===2">
										<el-radio-group v-model="a.optionValue" v-if="typeof(a.optionValue)=='string'">
											<el-radio :label="r" v-for="(r,ri) in a.options">{{r}}</el-radio>
										</el-radio-group>
										<el-checkbox-group v-model="a.optionValue"
											v-if="typeof(i.optionValue)=='object'">
											<el-checkbox :label="r" v-for="(r,ri) in a.options"></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="cont-right" v-if="i.type===1||i.type===2">
										<div class="right-item" :class="{'conform ':a.isActive==0}"
											@click="checkItem(i,0)">
											符合要求
											<img class="checkImg" v-if="a.isActive==0"
												src="@/assets/images/11639@3x.png" alt="">
										</div>
										<div class="right-item" :class="{'unConform':a.isActive==1}"
											@click="checkItem(i,1)">不符合要求
											<img class="checkImg" v-if="a.isActive==1"
												src="@/assets/images/21639@3x.png" alt="">
										</div>
									</div>

								</div>
								<div v-if="i.type===3" style="padding: 0 10px 0 30px;">
									<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="i.value">
									</el-input>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
			<span slot="footer">
				<el-button class="lft">跳 过</el-button>
				<el-button class="btn " v-if="active!=0" @click="lastStep">
					上一步
				</el-button>
				<el-button type="primary" v-if="active==0||active==1" class="btn btn-plus" @click="saveNext">
					保存并进入下一步
				</el-button>
				<el-button type="primary" v-if="active==2" class="btn btn-plus" @click="handleClose">
					完 成
				</el-button>
				<el-button class="btn" v-if="active==0" @click="handleClose">
					取 消
				</el-button>
			</span>

		</el-dialog>
	</div>
</template>
<script>
	import step from '@/components/zl-step.vue'
	export default {
		components: {
			step
		},
		data() {
			return {
				dialogVisible: false,
				handoverVisible: false,
				isActive: null,
				width: '382px',
				active: 0,
				stepArr: [{
						title: '填写材料接收审查表'
					},
					{
						title: '填写材料受理审查表'
					},
					{
						title: '填写材料书面审查表'
					},
				],
				list: [{
						title: '一、申请材料的装订',
						children: [{
								title: '1. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							},
							{
								title: '2. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: ''
							}
						]
					},
					{
						title: '二、申请材料的装订',
						children: [{
								title: '1. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							},
							{
								title: '2. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: ''
							}, {
								title: '3. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							},
							{
								title: '4. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: ''
							}
						]
					},
					{
						title: '三、申请材料的装订',
						children: [{
								title: '1. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							},
							{
								title: '2. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: ''
							}, {
								title: '3. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: '',
								options: ['军队受理点', '军工集团'],
								optionValue: ''
							},
							{
								title: '4. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: '',
								options: ['军队受理点'],
								optionValue: []
							}, {
								title: '5. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: '',
								options: ['军队受理点'],
								optionValue: []
							},
							{
								title: '6. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: '',
								options: ['军队受理点'],
								optionValue: []
							}, {
								title: '7. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							}
						]
					},
					{
						title: '四、申请材料的装订',
						children: [{
								title: '1. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							},
							{
								title: '2. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: ''
							}, {
								title: '3. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: '',
								options: ['军队受理点', '军工集团'],
								optionValue: ''
							},
							{
								title: '4. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: '',
								options: ['军队受理点'],
								optionValue: []
							}, {
								title: '5. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: '',
								options: ['军队受理点'],
								optionValue: []
							},
							{
								title: '6. A4 纸打印或复印，页码编排齐全、无缺号或跳号',
								isActive: null,
								value: '',
								options: ['军队受理点'],
								optionValue: []
							}, {
								title: '7. 3份纸质（含1份原件）每份盖骑缝章，1份电子版光盘',
								isActive: null,
								value: ''
							}
						]
					}
				],
				twolist: [{
					title: '一、申请材料的装订',
					children: [{
							title: '（含1份原件）每份盖骑缝章',
							isActive: null,
							type: 1,
							children: [{
								title: '1份电子版光盘',
								isActive: null,
								value: ''
							}, {
								title: '1份电子版光盘',
								isActive: null,
								value: ''
							}],
							value: ''
						},
						{
							title: ' A4纸打印或复印',
							isActive: null,
							type: 2,
							children: [{
								options: ['军队受理点', '军工集团', '总承包单位出具（含总承包合同和其他证明材料）', '总承包单位出具'],
								optionValue: '',
							}],
							value: ''
						},
						{
							title: '页码编排齐全、无缺号或跳号',
							isActive: null,
							type: 3,
							value: ''
						}
					]
				}]

			}
		},
		methods: {
			open() {
				this.active = 0
				this.dialogVisible = true

			},
			checkItem(i, val) {
				if (i.isActive == val) {
					i.isActive = null
				} else {
					i.isActive = val
				}

			},
			saveNext() {
				this.active += 1
			},
			lastStep() {
				this.active -= 1
			},
			handleClose() {
				this.dialogVisible = false
			},

			confirm() {

			},

		},
	}
</script>
<style lang="scss" scoped>
	/deep/ .el-dialog__header {
		padding: 16px 20px 10px;
		background-color: #f4f6fc;
		height: 50px;
		box-sizing: border-box;
	}

	/deep/ .el-dialog__body {
		padding: 30px;
		box-sizing: border-box;
	}

	/deep/ .el-dialog__title {
		font-family: Microsoft YaHei;
		font-size: 15px;
		font-weight: bold;
		font-stretch: normal;
		line-height: 20px;
		letter-spacing: 0px;
		color: #24262b;
	}

	/deep/ .el-form-item__label {
		font-family: Microsoft YaHei;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 19px;
		letter-spacing: 0px;
		color: #545454;
	}

	/deep/ .el-form-item {
		margin-bottom: 17px;
	}

	/deep/ .el-dialog__footer {
		padding-top: 0;
	}

	.head-descriptions {
		border-radius: 8px;
		margin: 24px 0;
		overflow: hidden;

		/deep/.el-descriptions__body {
			padding: 32px 40px;
			background-color: #f5f6fa;
		}

		/deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
			padding: 0;
		}
	}

	.content {
		max-height: 500px;
		overflow: auto;
	}

	.pane-content {
		.content-item {
			.item-title {
				// width: 40%;
				font-size: 16px;
				line-height: 24px;
				color: #24262b;
				margin: 20px 0;
			}

			.item-cont {
				font-size: 14px;
				line-height: 24px;
				color: #24262b;
				margin: 4px 32px;
				display: flex;
				justify-content: space-between;

				.cont-right {
					display: flex;
					justify-content: space-between;
					align-items: center;

					.right-item {
						margin-right: 10px;
						font-size: 14px;
						color: #545454;
						height: 30px;
						line-height: 30px;
						padding: 0 20px;
						box-sizing: border-box;
						background-color: #ffffff;
						border-radius: 4px;
						border: solid 1px #c4c4c4;
						position: relative;

						.checkImg {
							position: absolute;
							right: 0;
							bottom: 0;
							width: 20px;
							height: 18px;
						}
					}

					.conform {
						border-radius: 4px;
						border: solid 1px #0147eb;
						color: #0147eb;
					}

					.unConform {
						background-color: #ffffff;
						border: solid 1px #f04444;
						color: #f04444;
					}

					.el-input {
						width: 260px;
						height: 32px;
					}

					/deep/.el-input__inner {
						height: 32px !important;
					}
				}
			}

			.item2-cont {
				font-size: 14px;
				line-height: 24px;
				color: #24262b;
				margin: 4px 32px;

				// display: flex;
				// justify-content: space-between;
				.cont-title {
					font-size: 14px;
					padding: 10px;
					color: #24262b;
					display: flex;

					.square {
						width: 8px;
						height: 8px;
						margin: 8px 15px 0 0;
						background-color: #24262b;
					}
				}

				.cont-list {
					display: flex;
					justify-content: space-between;
					margin: 4px 0 4px 32px;
					.el-radio{
						margin: 8px;
					}
				}

				.cont-right {
					display: flex;
					justify-content: space-between;
					align-items: center;

					.right-item {
						margin-right: 10px;
						font-size: 14px;
						color: #545454;
						height: 30px;
						line-height: 30px;
						padding: 0 20px;
						box-sizing: border-box;
						background-color: #ffffff;
						border-radius: 4px;
						border: solid 1px #c4c4c4;
						position: relative;

						.checkImg {
							position: absolute;
							right: 0;
							bottom: 0;
							width: 20px;
							height: 18px;
						}
					}

					.conform {
						border-radius: 4px;
						border: solid 1px #0147eb;
						color: #0147eb;
					}

					.unConform {
						background-color: #ffffff;
						border: solid 1px #f04444;
						color: #f04444;
					}

					.el-input {
						width: 260px;
						height: 32px;
					}

					/deep/.el-input__inner {
						height: 32px !important;
					}
				}
			}
		}

		.conclusion {
			font-size: 20px;
			line-height: 24px;
			// font-weight: bold;
			color: #24262b;

			.conclusion-box {
				display: flex;
				padding: 32px;
				box-sizing: border-box;

				div:nth-child(1) {
					height: 32px;
					background-color: #ffffff;
					border-radius: 4px;
					border: solid 1px #c4c4c4;
					font-size: 14px;
					line-height: 32px;
					padding: 0 20px;
					color: #545454;
					box-sizing: border-box;
					margin-right: 8px;
				}

				div:nth-child(2) {
					height: 32px;
					background-color: #ffffff;
					border-radius: 4px;
					border: solid 1px #f04444;
					font-size: 14px;
					line-height: 32px;
					padding: 0 20px;
					box-sizing: border-box;
					color: #f04444;
				}
			}
		}
	}

	.btn {
		height: 40px;
	}

	.btn-plus {
		background-color: #0147eb;
	}

	.btn-bel {
		background-color: #F04444;
	}

	.lft {
		position: absolute;
		left: 30px;
	}

	.confirm_derive {
		display: flex;
		align-items: center;

		img {
			width: 88px;
			height: 88px;
			margin-right: 30px;
		}

		.text {
			div:nth-child(1) {
				font-size: 24px;
				line-height: 25px;
				color: #373738;
			}

			div:nth-child(2) {
				font-size: 14px;
				line-height: 40px;
				color: #373738;
			}
		}
	}
</style>
